import { withInstall } from "../utils/index.mjs";
import _PickerGroup from "./PickerGroup.mjs";
const PickerGroup = withInstall(_PickerGroup);
var stdin_default = PickerGroup;
import { pickerGroupProps } from "./PickerGroup.mjs";
export {
  PickerGroup,
  stdin_default as default,
  pickerGroupProps
};
